import { Box, Image, Flex, Text } from "@chakra-ui/react";
import React from "react";
import "../../Styles/main.css";
// import ShopByCategory from "./NewDesign/ShopByCategory/ShopByCategory";
import ShopByCategory from "../../Components/Home/NewDesign/ShopByCategory/ShopByCategory";
import TheTrendings from "./NewDesign/Cards/TheTrendings";
import AllProducts from "./NewDesign/Products/AllProducts";
import homeDecorBanner from "../../../src/assets/homeDecorBanner.png";
import { Link } from "react-router-dom";
import ILearned from "./NewDesign/ILearned";
import HomeSlider from "./HomeCrousel";
const Main = () => {
  return (
    <Box>
      <HomeSlider />
      <Box>
        <Box w={"92%"} m={"auto"} textAlign={"left"}>
          <TheTrendings />
        </Box>
        <Box
          w={"92%"}
          m={"auto"}
          mt={{ md: "0", base: "-30px" }}
          textAlign={"left"}
        >
          <ShopByCategory />
        </Box>
        <Box w={"92%"} m={"auto"} mt={4} textAlign={"left"}>
          <Link to={"/homeDecorAll"}>
            <Image
              src={homeDecorBanner}
              w={"100%"}
              m={"auto"}
              h={{ base: "80px", md: 200 }}
            />
          </Link>
        </Box>

        <Box w={"92%"} m={"auto"} mt={4} textAlign={"left"}>
          <AllProducts />
        </Box>
        <Box m={"auto"} w={"92%"} mt={4} textAlign={"left"} mb={10}>
          <ILearned />
        </Box>
      </Box>
    </Box>
  );
};

export default Main;
